module.exports = __webpack_public_path__ + "media/icons/award-icon-5c833b26.png";